import { useEffect, useState } from "react";
import fallbackImage from "../img/part-placeholder.svg";

export default function SafeImage({ src, alt = "", className = "", fallback = fallbackImage, ...props }) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const resolved = !src || failed ? fallback : src;

  return (
    <img
      src={resolved}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
      {...props}
    />
  );
}
